import { ArrowBack } from '@mui/icons-material';
import { Box, Divider, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import type { EnrichedEntity } from '@/lib/types';
import { EntityDetailContent } from './EntityDetailDialog';
import { EDITOR_DRAWER_WIDTH, EDITOR_PROSE_WIDTH, ENTITY_DRAWER_MAX_WIDTH } from './editor-drawer-layout';

export function EntityDetailDrawer({ entity, onClose }: { entity: EnrichedEntity | null; onClose: () => void }) {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  // Never narrower than the regular drawer; grow only into the margin beside the prose.
  const width = 'clamp(' + EDITOR_DRAWER_WIDTH + 'px, calc((100% + ' + EDITOR_DRAWER_WIDTH + 'px - ' + EDITOR_PROSE_WIDTH + 'px) / 2), ' + ENTITY_DRAWER_MAX_WIDTH + 'px)';

  if (mobile) {
    return <Drawer
      variant={'temporary'}
      anchor={'right'}
      open={!!entity}
      onClose={onClose}
      PaperProps={{ sx: { width: '90vw' } }}
      sx={{ zIndex: theme.zIndex.drawer + 2 }}
    >
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton onClick={onClose} aria-label={'Back'}><ArrowBack /></IconButton>
        <Typography noWrap>{entity?.name || entity?.title}</Typography>
      </Box>
      <Divider />
      <Box sx={{ overflowY: 'auto' }}><EntityDetailContent entity={entity} layout={'drawer'} /></Box>
    </Drawer>;
  }

  return <Drawer anchor={'right'} open={!!entity} variant={'persistent'}
    PaperProps={{ sx: { width: '100%', height: '100%', position: 'absolute', boxShadow: 12 } }}
    sx={{
      width,
      height: '100%',
      position: 'absolute',
      inset: '0 0 0 auto',
      zIndex: theme.zIndex.drawer + 2,
      pointerEvents: entity ? 'auto' : 'none',
      '& .MuiDrawer-paper': { boxSizing: 'border-box' },
    }}>
    <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
      <IconButton onClick={onClose} aria-label={'Back'}><ArrowBack /></IconButton>
      <Typography noWrap>{entity?.name || entity?.title}</Typography>
    </Box>
    <Divider />
    <Box sx={{ overflowY: 'auto' }}><EntityDetailContent entity={entity} layout={'drawer'} /></Box>
  </Drawer>;
}
